'use strict';

exports.__esModule = true;
exports.get = get;
exports.update = update;
exports.remove = remove;

var _apiClient = require('../network/api-client');

var _apiClient2 = _interopRequireDefault(_apiClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Wrapper for `/partner/defaults` API endpoint
 */

var API = {
  PARTNER_PREFERENCES: '/partner/preferences'
};
var includeAuth = true;

/**
 * Get Partner preferences
 * @returns {Promise} that resolves preferences
 */
function get() {
  return _apiClient2.default.get({ route: API.PARTNER_PREFERENCES, includeAuth: includeAuth });
}

/**
 * Update preferences
 * @param {Object} data `{prefKey: prefValue}`
 * @returns {Promise} that resolves preferences
 */
function update(data) {
  return _apiClient2.default.put({ route: API.PARTNER_PREFERENCES, data: data, includeAuth: includeAuth });
}

/**
 * Remove default setting
 * @param {String} field
 * @returns {Promise} nulls a the supplied key in Partner preferences
 */
function remove(field) {
  return _apiClient2.default.remove({ route: API.PARTNER_PREFERENCES + '/' + field });
}

var defaults = {
  get: get,
  update: update,
  remove: remove
};

exports.default = defaults;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/partner/preferences.js
// module id = 1084
// module chunks = 0